import { render, staticRenderFns } from "./Autoreply.vue?vue&type=template&id=2d22c107&scoped=true"
import script from "./Autoreply.vue?vue&type=script&lang=js"
export * from "./Autoreply.vue?vue&type=script&lang=js"
import style0 from "./Autoreply.vue?vue&type=style&index=0&id=2d22c107&prod&scoped=true&lang=css"
import style1 from "./Autoreply.vue?vue&type=style&index=1&id=2d22c107&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d22c107",
  null
  
)

export default component.exports